const IMAGE_SIZES =
  '(max-width: 768px) 100vw, (max-width: 1024px) 57vw, (max-width: 1440px) 60vw, 1684px';

export { IMAGE_SIZES };
